import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type { FC } from 'react'
import { useSelector } from 'react-redux'

import { NODE_FRAME } from '@/constants/constants'
import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import type { TreeItemVariants } from '@/types'
import css from './PageContentViewName.module.scss'

const PageContentViewName: FC<{
  name: string
  variant: TreeItemVariants
}> = (props) => {
  const isNeutral = useSelector(migrationProjectSelector.getIsProjectNeutral)

  return (
    <div
      className={cx(css.container, {
        [css.dashed]: props.variant === NODE_FRAME,
        [css.neutral]: isNeutral,
      })}
    >
      <div data-testid="page-name" className={css.name}>
        {props.name === ' ' ? '\u00A0' : props.name || DEFAULT_PAGE_NAME}
      </div>
    </div>
  )
}

export default PageContentViewName
